import Axios from '@/components/api/axios.js'

/**********************************************************************************
 * 历史数据
 **********************************************************************************/
export default {
	getPumpRunInfoByTime: (deviceNo,startTime,endTime,success,failure) => {
		Axios.post('/history/getPumpRunInfo.do', {
			deviceNo,
			startTime,
			endTime
		},success,failure)
   },
	getEnergyLossList:(unitId,dayType,startTime,endTime) => {
		Axios.post('/history/getEnergyLossList.do', {
			unitId,
			dayType,
			startTime,
			endTime
		})
	},
	/**
	 * 查询手动上报历史值
	 * @param {list} variableNames 变量名
	 * @param {Long} bgTime 开始时间,以时间戳格式传
	 * @param {Long} endTime 结束时间,以时间戳格式传
	 * @param {String} dateType 时间类型(date,month)
	 */
	searchVariableCustomizeHistory: (variableNames, dateTime,dateType, success, failure) => {
		Axios.post('/history/searchVariableCustomizeHistory.do', {
			variableNames,
			dateTime,
			dateType
		}, success, failure)
	},
	/**
	 * 查询手动上报历史值
	 * @param {list} valueList 值数组
	 * @param {String} dateType 时间类型(date,month)
	 * @param{Long} dateTime 时间
	 */
	updateHistory: (valueObject,dateType,dateTime,success, failure) => {
		Axios.post('/history/updateHistory.do', {
			valueObject,
			dateType,
			dateTime,
		}, success, failure)
	},
	/**
	 * 查询设备的历史数据,可自定义日期区间，最详细的5分钟记录
	 * @param {String} deviceNos 设备no,多个用逗号隔开
	 * @param {Long} bgTime 开始时间,以时间戳格式传
	 * @param {Long} endTime 结束时间,以时间戳格式传
	 */
	searchDeviceHistory: (deviceNos, bgTime, endTime, success, failure) => {
		Axios.post('/history/searchDeviceHistory.do', {
			deviceNos,
			bgTime,
			endTime
		}, success, failure)
	},
	/**
	 * 查询变量历史数据
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {Long} bgTime 开始时间,以时间戳格式传
	 * @param {Long} endTime 结束时间,以时间戳格式传
	 */
	searchVariableHistory: (variableNames, bgTime, endTime, success, failure) => {
		Axios.post('/history/searchVariableHistory.do', {
			variableNames,
			bgTime,
			endTime
		}, success, failure)
	},
	/**
	 * 查询设备的历史数据
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {String} dateType 时间周期，日——day,周——week,月——month,季——quarter,年——year,
	 * @param {Long} time 开始时间,以时间戳格式传
	 */
	searchVariableHistoryWithDateType: (variableNames, dateType, time, success, failure) => {
		Axios.post('/history/searchVariableHistoryWithDateType.do', {
			variableNames,
			dateType,
			time
		}, success, failure)
	},

	/**
	 * 查询设备的开关情况
	 * @param {String} deviceNos 设备no,多个用逗号隔开
	 * @param {Long} bgTime 开始时间,以时间戳格式传
	 * @param {Long} endTime 结束时间,以时间戳格式传
	 */
	searchDeviceCurrentSwitch: (deviceNos, bgTime, endTime, success, failure) => {
		Axios.post('/history/searchDeviceCurrentSwitch.do', {
			deviceNos,
			bgTime,
			endTime
		}, success, failure)
	},
	getEnergyTypeHistoryDifferenceRanking: (energyTypeIdList, dateType, time, endTime, success, failure) => {
		Axios.post('/history/getEnergyTypeHistoryDifferenceRanking.do', {
			energyTypeIdList,
			dateType,
			time,
			endTime,
		}, success, failure)
	},
	/**
	 * 查询指定变量的查询日周月季年的差值
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {String} dateType 时间周期，日——day,周——week,月——month,季——quarter,年——year,
	 * @param {Long} time 开始时间,以时间戳格式传
	 */
	getHistoryDifferenceRanking: (variableNames, dateType, time, endTime, success, failure) => {
		Axios.post('/history/getHistoryDifferenceRanking.do', {
			variableNames,
			dateType,
			time,
			endTime,
		}, success, failure)
	},
	/**
	 * 查询指定列表的需量在指定月份的叠加最大曲线，不同变量组合可能不一致
	 * @param {String} time
	 * @param {String} variableNames
	 * @param {Object} success
	 * @param {Object} failure
	 * @param {String} day
	 */
	getMonthLoadDemandHistory(time, day, variableNames, success, failure) {
		Axios.post('/history/getMonthLoadDemandHistory.do', {
			time,
			day,
			variableNames
		}, success, failure)
	},
	/**
	 * 查询指定变量在指定时间范围内大于某个值的范围时间之和（数值单位为分钟）
	 * @param {Long} beginTime 开始时间,以时间戳格式传
	 * @param {Long} endTime 结束时间,以时间戳格式传
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {double} value 值
	 */
	getSumForGreaterThanValue(beginTime, endTime, variableNames, value, success, failure) {
		Axios.post('/history/getSumForGreaterThanValue.do', {
			beginTime,
			endTime,
			variableNames,
			value
		}, success, failure)
	},
	/**
	 * 查询指定变量在指定时间范围内大于某个值的范围
	 * @param {Long} beginTime 开始时间,以时间戳格式传
	 * @param {Long} endTime 结束时间,以时间戳格式传
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {double} value 值
	 */
	getRangeForGreaterThanValue(beginTime, endTime, variableNames, value, success, failure) {
		Axios.post('/history/getRangeForGreaterThanValue.do', {
			beginTime,
			endTime,
			variableNames,
			value
		}, success, failure)
	},
	/**
	 * 历史示值
	 * @param {Long} beginTime 开始时间,以时间戳格式传
	 * @param {Long} endTime 结束时间,以时间戳格式传
	 * @param {String} deviceNos 设备no,多个用逗号隔开
	 * * @param {String} type tc_天澄定制 wedo_通用（废除）
	 */
	searchHistoryIndicationValue(deviceNos, beginTime, endTime, success, failure) {
		Axios.post('/history/searchHistoryIndicationValue.do', {
			deviceNos,
			beginTime,
			endTime,
		}, success, failure)
	},
	/**
	 * 查询指定变量的本日最大值最小值本月最大值最小值
	 * @param {Long} variableNames 变量名称
	 * @param {Long} time 时间
	 */
	getVariableMaxAndMin(variableNames, time, success, failure) {
		Axios.post('/history/getVariableMaxAndMin.do', {
			variableNames,
			time,
		}, success, failure)
	},
	/**
	 * 查找单位下所有设备的开关次数统计
	 * @param {String} unitId 单位id
	 * @param {Long} bgTime 开始时间
	 * @param {Long} endTime 结束时间
	 */
	serchSwitchTotal(unitId, bgTime,endTime, success, failure) {
		Axios.post('/history/serchSwitchTotal.do', {
			unitId,
			bgTime,
			endTime,
		}, success, failure)
	},
	/**
	 * 查找单位下所有设备的遥控次数
	 * @param {String} unitId 单位id
	 * @param {Long} bgTime 开始时间
	 * @param {Long} endTime 结束时间
	 */
	unitControlCount(unitId, bgTime,endTime, success, failure) {
		Axios.post('/history/unitControlCount.do', {
			unitId,
			bgTime,
			endTime,
		}, success, failure)
	},
}
